<template>
  <div class="pageContol classReviewDetail">
    <div class="framePage">
      <div class="framePage-title">
        <span v-if="stu == 'classReviewDetail'">
          <em>当前位置： </em>
          <a href="javascript:;" @click="$router.back()">班级审核</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">详情</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">课程详情</a>
        </span>
        <span v-if="stus == 'stus'">
          <em>当前位置： </em>
          <a href="javascript:;" @click="$router.back()">班级列表</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">课程列表</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">课程详情</a>
        </span>
        <span v-else>
          <em>当前位置： </em>
          <a href="javascript:;" @click="$router.back()">我的课程</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">课程详情</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="ovy-a">
          <h3 style="padding-bottom: 20px">课程基本信息</h3>
          <div>
            <el-form :inline="true" ref="ruleForm" label-width="10rem">
              <el-form-item label="课程名称：" class="form-inline">
                <p>{{ ruleForm.courseName }}</p>
              </el-form-item>
              <el-form-item
                v-show="ruleForm.trainTypeNamePath"
                label="培训类型："
                class="form-inline"
              >
                <p>{{ ruleForm.trainTypeNamePath || "" }}</p>
              </el-form-item>
              <el-form-item
                v-show="ruleForm.industryNamePath"
                label="行业类型："
                class="form-inline"
              >
                <p>{{ ruleForm.industryNamePath || "" }}</p>
              </el-form-item>
              <el-form-item
                v-show="ruleForm.postName"
                label="岗位类型："
                class="form-inline"
              >
                <p>{{ ruleForm.postName || "" }}</p>
              </el-form-item>
              <el-form-item
                v-show="ruleForm.occupationNamePath"
                label="职业/工种："
                class="form-inline"
              >
                <p>{{ ruleForm.occupationNamePath || "" }}</p>
              </el-form-item>
              <el-form-item
                v-show="ruleForm.trainLevelName"
                label="培训等级："
                class="form-inline"
              >
                <p>{{ ruleForm.trainLevelName || "" }}</p>
              </el-form-item>

            </el-form>
            <el-form ref="ruleForm" label-width="10rem">
              <el-form-item label="课程详情：" prop="context" class="form-item">
                <div
                  v-html="ruleForm.context"
                  ref="editor"
                  style="width: 100%; position: relative; z-index: 2"
                />
              </el-form-item>
              <el-form-item label="课程图片：" prop="thumbnail">
                <div class="img-el-upload" style="width: 256px">
                  <el-image
                    :src="ruleForm.thumbnail || require('@/assets/develop.png')"
                    fit="contain"
                  ></el-image>
                </div>
              </el-form-item>
              <el-form-item
                label="讲师备注："
                prop="lecturer"
                class="form-inline editLecture"
              >
                <p v-if="editBtn">{{ ruleForm.lecturer || "无" }}</p>
                <el-input v-model="ruleForm.lecturer" v-else></el-input>
                <div v-if="editBtn && stu == 'classReviewDetail'">
                  <el-button size="mini" class="bgc-bv" @click="lecturerClick"
                    >编辑</el-button
                  >
                </div>
                <div
                  v-else
                  v-show="stu == 'classReviewDetail'"
                  style="display: flex; height: max-content; margin-left: 10px"
                >
                  <el-button size="mini" class="bgc-bv" @click="doSave"
                    >保存</el-button
                  >
                  <el-button size="mini" class="bgc-bv" @click="doGive"
                    >取消</el-button
                  >
                </div>
              </el-form-item>
              <!-- <el-form-item v-if="editBtn && stu =='classReviewDetail'" class="form-inline">
                  <el-button style="padding:8px 20px" class="bgc-bv" @click="lecturerClick">编辑</el-button>
                </el-form-item>
                <el-form-item v-else v-show="stu =='classReviewDetail'" class="form-inline">
                  <el-button style="padding:8px 20px" class="bgc-bv" @click="doSave">保存</el-button>
                  <el-button style="padding:8px 20px" class="bgc-bv" @click="doGive">取消</el-button>
                </el-form-item> -->
            </el-form>
          </div>

          <h3 style="padding-bottom: 20px">总学时设置</h3>
          <div class="lessonNum">
            <span>总课时：{{kpointTotalClassNum}}</span>
            <span>视频累计时长：{{ getTime(duration) || ruleForm.durationStr }}</span>
            <span>所选课件总学时：{{ lessonNum }}学时</span>
            <span>必修课总学时：{{ lessonNumMust }}学时</span>
            <span
              >选修课总学时：{{
                (lessonNum - lessonNumMust).toFixed(1) || 0
              }}学时</span
            >
          </div>
          <p class="lessNumcount">
            <span>要求完成总学时：</span>
            <!-- <el-input
              v-model="lessnumcount"
              size="small"
              style="width:10rem"
              :disabled="auditState == '30' ? true: false"
            ></el-input>-->
            <el-input-number
              v-model="lessnumcount"
              @change="handleChange"
              size="small"
              style="width: 10rem"
              controls-position="right"
              :min="0"
              :step="0.1"
              :disabled="true"
            ></el-input-number>
          </p>
          <h3 style="padding: 20px 0">课程章节</h3>
          <el-checkbox v-model="wocao" @change="selectChange" :disabled="true" style="margin-left: 24px;">全选</el-checkbox>
          <el-tree
            ref="tree"
            :data="data"
            :show-checkbox="stu != 'classReviewDetail'"
            node-key="courseKpointId"
            default-expand-all
            :expand-on-click-node="false"
            :default-checked-keys="this.selects"
            :props="defaultProps"
            @check-change="getChecked"
          >
            <span class="custom-tree-node" slot-scope="{ data }">
              <template v-if="data.level == 1">
                <span style="width: 44px; text-align: left">
                  <span class="level" style="margin-right: 10px">
                    <!-- 一级 -->
                    {{ data.chapterNum }}
                  </span>
                </span>
                <p :title="data.catalogName" class="ellipsis">
                  {{ data.catalogName }}
                </p>
              </template>
              <template v-else-if="data.level == 2">
                <!-- <div> -->
                <span style="width: 44px; text-align: left">
                  <span class="level" style="margin-right: 10px">
                    {{ data.chapterNum }}
                  </span>
                </span>
                <span
                  v-if="data.list.length > 0"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <i class="courseIcon" v-if="data.list[0].kpointId"></i>
                  <i class="paperIcon" v-else></i>
                </span>
                <span
                  v-text="data.catalogName"
                  class="ellipsis"
                  style="width: 33.5rem"
                  :title="data.catalogName"
                ></span>
                <span>{{ data.kpointDurationStr }}</span>
                <el-button
                  v-if="stu != 'classReviewDetail'"
                  type="text"
                  @click="showVideo(data)"
                  size="mini"
                  >预览</el-button
                >
                <el-button
                  v-else
                  type="text"
                  @click="showVideo2(data)"
                  size="mini"
                  >预览</el-button
                >
                <el-radio-group
                  v-model="data.requiredState"
                  v-show="stu != 'classReviewDetail'"
                  class="set-food-select"
                  size="mini"
                  value-key="specId"
                  :disabled="true"
                  @change="change(data)"
                >
                  <el-radio :label="true">必修课</el-radio>
                  <el-radio :label="false">选修课</el-radio>
                </el-radio-group>
              </template>
              <template v-else>
                <span
                  v-text="data.catalogName"
                  :title="data.catalogName"
                  class="ellipsiss"
                  v-if="stu != 'classReviewDetail'"
                ></span>
                <span
                  v-else
                  class="ellipsiss"
                  :title="data.title + ':' + data.catalogName"
                  >{{ data.title }}：{{
                    data.catalogName ||
                    (data.title == "授课讲师" ? "无讲师" : "无习题")
                  }}</span
                >
                <el-button
                  type="text"
                  @click="showPaper(data)"
                  size="mini"
                  v-show="data.paperId"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  @click="show(data)"
                  size="mini"
                  v-show="data.qualificationImageId"
                  class="dataqualificationImageId"
                  >预览</el-button
                >
              </template>
            </span>
          </el-tree>
          <div
            style="
              display: flex;
              justify-content: center;
              left: 50%;
              right: 50%;
            "
            v-show="auditState != '30'"
          >
            <el-button @click="$router.back()" class="bgc-bv">取消</el-button>
            <el-button
              @click="getCheckedNodes"
              class="bgc-bv"
              v-show="stu != 'classReviewDetail'"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="dialogVisible1"
      :title="videotitle"
      :visible.sync="dialogVisible1"
      width="60%"
      :before-close="handleClose"
    >
      <player_2
        :videoId="videoId"
        :courseId="courseId"
        :kpointId="kpointId"
        :videoTime="videoTime"
        :kpointSource="kpointSource"
        v-if="videoType"
        ref="palyer"
      />
      <player_1
        :videoId="videoId"
        :courseId="courseId"
        :kpointId="kpointId"
        :videoTime="videoTime"
        :kpointSource="kpointSource"
        v-else
        ref="palyer"
      />
    </el-dialog>
    <PaperShow ref="PaperShow" />
    <el-dialog
      :title="'授课讲师：' + teacherName"
      :visible.sync="dialogVisible"
      width="40%"
      top="2%"
      @close="Close"
    >
      <el-image
        :src="src"
        class="imgBoxs"
        oncontextmenu="return false;"
        ondragstart="return false;"
      />
    </el-dialog>
  </div>
</template>
<script>
import { console } from "../../../utils/helper";

let id = 1000;
import List from "@/mixins/List";
import PaperShow from "@/views/resourse/popup/PaperShow";
import player_1 from "@/components/player";
import player_2 from "@/components/playerTrysee";
import { createSwigger, distorySwigger } from "../../../utils/swigger";
import { duration } from "moment";
export default {
  name: "seeClassMinsCtr",
  components: {
    PaperShow,
    player_1,
    player_2,
  },
  mixins: [List],
  data() {
    return {
      wocao:true,
      dialogVisible: false,
      src: "",
      teacherName: "",
      data: [],
      defaultProps: {
        id: "courseKpointId",
        children: "children",
        label: "courseKpointId",
      },
      lessnumcount: "",
      ruleForm: {
        createId: "",
        courseName: "", // 课程名称
        context: "", //课程详情
        thumbnail: "",
        trainTypeNamePath: "", // 培训类型名称树
        postName: "", // 岗位名称
        industrynamePath: "", // 行业名称树
        lecturer: "",
        kpointTotalNum:"" //总课时
      },
      lessonNum: 0, //课程总学时哦
      lessonNumMust: 0, // 必修学时
      lessonNumDemand: 0, // 要求完成总学时
      kpointTotalClassNum:0, // 总课时
      auditState: "",
      selects: [],
      projectId: "",
      courseId: "",
      stu: "",
      videoId: "", // 視頻id
      videoType: null, // true-可以看；false-试看
      dialogVisible1: false,
      videotitle: "",
      videoTime: "",
      status: 1,
      editBtn: true, //
      duration: 0,
    };
  },
  created() {
    this.auditState = this.$route.query.auditState;
    this.courseId = this.$route.query.courseId;
    this.stu =
      this.$route.query.stu == "view"
        ? "classReviewDetail"
        : this.$route.query.stu;
    this.stus = this.$route.query.stus;
    this.projectId = sessionStorage.getItem("projectId");
    this.lessonNumMust = 0;
    this.getData();
    this.$nextTick(() => {
      this.getDetail();
    });
  },

  mounted() {},
  methods: {
    handleClose() {
      (this.dialogVisible1 = false), (this.status = 3);
      this.$refs.palyer.dd();
      distorySwigger();
    },
    getDetail() {
      this.$post(
        this.stus == "stus"
          ? "/biz/projectCourseOutline/selectOutlineByProjectCourseId"
          : "/biz/projectCourseOutline/auditSelectOutlineByProjectCourseId",
        {
          projectCourseId: this.$route.query.projectCourseId,
        }
      ).then((result) => {
        const data = result.data || {};
        if (result.status === "0") {
          this.ruleForm = {
            projectCourseId: data.projectCourseBo.projectCourseId,
            courseName: data.editDisplayBO.courseName, // 课程名称
            context: data.editDisplayBO.context, //课程详情
            thumbnail: data.editDisplayBO.logoURL,
            lecturer: data.editDisplayBO.lecturer,
            trainTypeNamePath: data.editDisplayBO.trainTypeNamePath,
            postName: data.editDisplayBO.postName,
            industryNamePath: data.editDisplayBO.industryNamePath,
            occupationNamePath: data.editDisplayBO.occupationNamePath,
            trainLevelName: data.editDisplayBO.trainLevelName
          };
          //   for (let index = 0; index < data.selects.length; index++) {
          //     console.log(data.selects[index]);
          //   if(data.editDisplayBO.nodes[index].courseKpointId == data.selects[index]) {
          //     console.log('2222');
          //     console.log(data.editDisplayBO.nodes[index].kpointDuration);
          //     this.duration  += data.editDisplayBO.nodes[index].kpointDuration
          //       console.log(this.duration);
          //   }

          // }
          this.selects = data.selects.map(Number);
          this.lessnumcount = data.projectCourseBo.lessonNumDemand;
          this.lessonNum = Number(data.projectCourseBo.lessonNum);
          this.lessonNumMust = Number(data.projectCourseBo.lessonNumMust);
          this.kpointTotalClassNum = Number(data.editDisplayBO.kpointTotalClassNum);
          let duration = 0;
          if (this.stus == "stus") {
            for (let i = 0; i < data.editDisplayBO.nodes.length; i++) {
              if (!data.editDisplayBO.nodes[i].child) {
                if (
                  data.selects.indexOf(
                    data.editDisplayBO.nodes[i].courseKpointId
                  ) > -1
                ) {
                  duration += data.editDisplayBO.nodes[i].kpointDuration;
                }
              } else {
                for (
                  let j = 0;
                  j < data.editDisplayBO.nodes[i].child.length;
                  j++
                ) {
                  if (
                    data.selects.indexOf(
                      data.editDisplayBO.nodes[i].child[j].courseKpointId
                    ) > -1
                  ) {
                    duration +=
                      data.editDisplayBO.nodes[i].child[j].kpointDuration;
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < data.editDisplayBO.nodes.length; i++) {
              if (!data.editDisplayBO.nodes[i].child) {
                duration += data.editDisplayBO.nodes[i].kpointDuration;
              } else {
                for (
                  let j = 0;
                  j < data.editDisplayBO.nodes[i].child.length;
                  j++
                ) {
                  duration +=
                    data.editDisplayBO.nodes[i].child[j].kpointDuration;
                }
              }
            }
          }
          this.duration = duration;
          this.creatData(data.editDisplayBO);
        }
      });
    },
    creatData(data = {}) {
      let list = [];
      this.chapterSchema = data.chapterSchema;
      if (data.chapterSchema) {
        // 样式一 ------> 三层
        data.nodes.forEach((element) => {
          let nodeList = [];
          list.push({
            courseKpointId: element.courseKpointId,
            catalogName: element.catalogName,
            parentNodeId: element.parentNodeId,
            children: nodeList,
            level: 1,
            disabled:true
          });
          (element.child || []).forEach((obj) => {
            nodeList.push(this.created2dom(obj));
          });
        });
      } else {
        data.nodes.forEach((element) => {
          list.push(this.created2dom(element));
        });
      }
      this.data = list;
      this.mapData(list);
    },
    created2dom(obj) {
      let children = [];
      if (this.stu == "classReviewDetail") {
        if (obj.paperId || obj.teacherPathName) {
          children = [
            {
              title: "课后习题",
              catalogName: obj.paperName,
              courseKpointId: obj.courseKpointId,
              sourceCourseKpointId: obj.courseKpointId,
              level: 3,
              paperId: obj.paperId,
              disabled:true
            },
            {
              title: "授课讲师",
              catalogName: obj.teacherPathName,
              level: 3,
              qualificationImageId: obj.qualificationImageId,
            },
          ];
        }
      } else {
        if (obj.paperId) {
          children = [
            {
              title: "课后习题",
              catalogName: obj.paperName,
              courseKpointId: obj.courseKpointId,
              sourceCourseKpointId: obj.courseKpointId,
              level: 3,
              paperId: obj.paperId,
              disabled:true
            },
          ];
        }
      }

      let listArr = [];
      if (obj.kpointVideoId) {
        obj.list = listArr;
        listArr.push({
          kpointVideoId: obj.kpointVideoId,
          kpointId: obj.kpointId,
          kpointSource: obj.kpointSource,
        });
      } else if (obj.paperId) {
        obj.list = listArr;
        listArr.push({
          paperId: obj.paperId,
          paperName: obj.paperName,
          kpointSource: obj.kpointSource,
        });
      }
      //判断kpointId存在，paperId存在，带试卷的课件，kpointId不存在，paperId存在是单元测试
      if (obj.kpointId) {
        return {
          catalogName: obj.catalogName,
          parentNodeId: obj.parentNodeId,
          kpointLessonNum: obj.kpointLessonNum,
          level: 2,
          list: listArr,
          children: children,
          requiredState: obj.requiredState,
          section: obj.section,
          courseKpointId: obj.courseKpointId,
          sourceCourseId: this.courseId,
          sourceCourseKpointId: obj.courseKpointId,
          kpointId: obj.kpointId,
          requiredState: obj.requiredState,
          disabled:true
        };
      } else {
        return {
          catalogName: obj.catalogName,
          parentNodeId: obj.parentNodeId,
          kpointLessonNum: obj.kpointLessonNum,
          level: 2,
          list: listArr,
          children: [],
          requiredState: obj.requiredState,
          section: obj.section,
          courseKpointId: obj.courseKpointId,
          sourceCourseId: this.courseId,
          sourceCourseKpointId: obj.courseKpointId,
          kpointId: obj.kpointId,
          disabled:true,
          paperId: obj.paperId,
          paperName: obj.paperName,
          kpointDuration: obj.kpointDuration,
          kpointDurationStr: obj.kpointDurationStr,
        };
      }
    },
    change(data) {
      let num = 0;
      this.$refs.tree.getCheckedNodes().map((item, index) => {
        if (item.level == 2) {
          if (item.requiredState && item.requiredState == true) {
            if (item.kpointLessonNum) {
              num += item.kpointLessonNum;
            }
          }
        }
      });
      this.lessonNumMust = num.toFixed(1);
      this.lessnumcount = num.toFixed(1);
    },
    getChecked(data, checked, indeterminate) {
      let num = 0;
      let ElectiveNum = 0;
      let duration = 0;
      this.$refs.tree.getCheckedNodes().map((item, index) => {
        if (item.level == 2) {
          if (item.requiredState == true) {
            if (item.kpointLessonNum) {
              num += item.kpointLessonNum;
            }
          } else {
            let kpointLessonNum =
              item.kpointLessonNum && item.kpointLessonNum != undefined
                ? item.kpointLessonNum
                : 0;
            ElectiveNum += kpointLessonNum;
          }
          duration += item.kpointDuration;
        }
      });

      this.lessonNum = (num + ElectiveNum).toFixed(1);
      this.lessonNumMust = num.toFixed(1);
      this.lessnumcount = num.toFixed(1);
      this.duration = duration;
      // 计算总课时
      this.kpointTotalClassNum = parseInt(this.duration/2700*100)/100;


      // if (data.requiredState) {
      //   if (data.requiredState && checked) {
      //     this.lessnumcount += data.kpointLessonNum;
      //   } else if (data.requiredState == false) {
      //     return;
      //   } else {
      //     this.lessnumcount -= data.kpointLessonNum;
      //   }
      // }
    },
    showPaper(data) {
      this.$refs.PaperShow.showPopUp(data.paperId); // 打开弹窗预览试题
    },
    show(data) {
      this.dialogVisible = true;
      this.teacherName = data.catalogName;
      this.src = data.qualificationImageId;
    },
    // 全选
    selectChange(type) {
      let res = this.$refs.tree;
      let nodes = res.getCheckedNodes(true, true);
      this.batchSelect(this.data, res, type, nodes);  
    },
    batchSelect(nodes, refs, flag, selecteds) {
      if (typeof nodes != "undefined") {
        nodes.forEach((element) => {
          refs.setChecked(element, flag, true);
        });
      }
      if (typeof selecteds != "undefined") {
        selecteds.forEach((node) => {
          refs.setChecked(node, flag, true);
        });
      }
    },
    /**
     * 保存
     */
    getCheckedNodes() {
      const cClessonNum = sessionStorage.getItem("cClessonNum");
      const projectSource = sessionStorage.getItem("projectSource");
      let checked = [];
      let checkeds = [];
      checked = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      if (this.lessnumcount == "") {
        this.$message({
          message: "请输入要求完成总学时",
          type: "warning",
        });
        return false;
      }
      if (this.lessnumcount > this.lessonNum) {
        this.$message({
          message: "要求完成总学时不能大于所选课件总学时",
          type: "warning",
        });
        return false;
      }
      if (checked.length == 0) {
        this.$message({
          message: "请选择课程编排",
          type: "warning",
        });
        return false;
      }
      if (projectSource == "20") {
        if (
          this.lessonNumDemand != cClessonNum &&
          this.lessonNum != cClessonNum
        ) {
          this.$message({
            message:
              "所选课件总学时和要求完成总学时必须等于规定学时,(" +
              cClessonNum +
              "学时)",
            type: "warning",
          });
        }
      }
      //判断要求完成总学时必须为整数
      if (!this.isInteger(this.lessonNum)) {
        this.$message({ message: "要求完成总学时必须为整数", type: "warning" });
        return false;
      }
      //判断要求必修课总学时必须为整数
      if (!this.isInteger(this.lessonNumMust)) {
        this.$message({
          message: "要求必修课总学时必须为整数",
          type: "warning",
        });
        return false;
      }
      //判断要求所选课件总学时必须为整数
      if (!this.isInteger(this.lessnumcount)) {
        this.$message({
          message: "要求所选课件总学时必须为整数",
          type: "warning",
        });
        return false;
      }
      let parmar = {
        lessonNum: Math.floor(this.lessonNum),
        lessonNumDemand: Math.floor(this.lessnumcount),
        lessonNumMust: Math.floor(this.lessonNumMust),
        courseId: this.$route.query.courseId,
        modify: 1,
        projectId: this.projectId,
        selectIds: checked,
        selectNode: this.data,
        projectCourseId: this.$route.query.projectCourseId,
      };
      this.$post("/biz/projectCourseOutline/disposeProjectCourse", parmar)
        .then((ret) => {
          if (ret.status == 0) {
            this.$message({
              message: ret.message,
              type: "success",
            });
            this.$router.back();
          }
        })
        .catch((err) => {
          return;
        });
    },
    isInteger(obj) {
      return Math.floor(obj) == obj;
    },
    // 预览
    showVideo(data) {
      console.log(data);
      let _this = this;
      //单元测试打开是题库
      if (data.list[0].kpointVideoId) {
        _this
          .$post("/biz/courseware/auth", {
            videoId: data.list[0].kpointVideoId,
          })
          .then((result) => {
            _this.videoId = data.list[0].kpointVideoId;
            _this.videoType = result.data.trySee;
            _this.videoTime = result.data.duration;
            _this.videotitle = data.catalogName;
            _this.courseId = _this.courseId;
            _this.kpointId = data.kpointId;
            _this.kpointSource = data.list[0].kpointSource;
            _this.dialogVisible1 = true;
          });
      } else {
        this.showPaper(data);
      }
    },
    showVideo2(data) {
      //单元测试打开是题库
      if (data.list[0].kpointVideoId) {
        this.$store.dispatch("handleVideoUrl", {
          kpointVideoId: data.list[0].kpointVideoId,
          kpointName: data.catalogName,
          kpointId: data.list[0].kpointId,
          courseId: this.courseId,
        });
      }
      if (!data.list[0].kpointVideoId && data.paperId) {
        this.showPaper(data);
      }
    },
    mapData(data) {
      //样式1下

      data.forEach((item, i) => {
        item["chapterNum"] = Number(i) + 1;
        item.children.forEach((el, k) => {
          el["chapterNum"] = Number(i) + 1 + "-" + (Number(k) + 1);
        });
      });

      this.$nextTick(() => {
        this.data = data;
      });
    },
    Close() {
      this.dialogVisible = false;
    },
    lecturerClick() {
      this.editBtn = false;
    },
    doSave() {
      const that = this;

      let params = {
        lecturer: that.ruleForm.lecturer,
        projectCourseId: that.$route.query.projectCourseId,
      };
      that.$post("/run/projectCourse/lecturer/update", params).then((ret) => {
        that.editBtn = true;
        // that.getEdit(that.parperId);
        // that.subShow = true;
      });
    },
    doGive() {
      // this.getData(-1);
      this.editBtn = true;
    },
    getTime(val) {


      if (!val) {
        return "0秒";
      }
      let h = parseInt(val / 60 / 60);
      let m = parseInt((val % 3600) / 60);
      let s = val % 60;
      if (h < 9) {
        h = "0" + h;
      }
      if (m < 9) {
        m = "0" + m;
      }
      if (s < 9) {
        s = "0" + s;
      }
      return (
        (h != "00" ? h + "时" : "") +
          (m != "00" ? m + "分" : "") +
          (s != "00" ? s + "秒" : "") || ""
      );
    },
  },
};
</script>
<style lang="less">
.imgbox {
  .el-form-item__content {
    width: 256px !important;
    height: 156px;
  }
}
.form-inline {
  width: 45%;
  p {
    width: 20rem;
  }
}
.classReviewDetail {
  .lessNumcount {
    .el-icon-arrow-down:before {
      content: "\e6df" !important;
    }
  }
}
.el-image {
  display: block;
}

.imgBoxs {
  display: flex;
  > img {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    z-index: 1;
  }
}
.editLecture {
  .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="less" scoped>
.Basicinformation {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 50%;
    padding: 10px 0;
  }
  .information {
    display: flex;
    flex-wrap: wrap;
    .information-item {
      width: 50%;
    }
  }
}
.lessonNum {
  display: flex;
  padding: 1rem;
  span {
    padding: 0 1rem;
  }
}
.lessNumcount {
  display: flex;
  align-items: center;
  padding: 0 2rem;
  span {
    width: 10rem;
  }
}
.custom-tree-node {
  display: flex;
  align-items: center;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 40rem;
  font-size: 14px;
}
.ellipsiss {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 40rem;
  font-size: 14px;
}
.bottom-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-tree-node {
  .el-form-item {
    margin-bottom: 0px;
  }
}
.qualificationImageId {
  .el-image {
    display: flex;
    height: 500px;
  }
}
.dataqualificationImageId {
  margin-left: -2px;
}
.imgUpload {
  display: flex;
  justify-content: center;
}
.courseIcon {
  width: 14px;
  height: 14px;
  margin-right: 5px;
  display: inline-block;
  background: url("../../../assets/courseIcon.png") no-repeat;
  background-size: cover;
}
.paperIcon {
  width: 14px;
  height: 14px;
  margin-right: 5px;
  display: inline-block;
  background: url("../../../assets/paperIcon.png") no-repeat;
  background-size: cover;
}
.level {
  padding: 3px;
  border-radius: 6px;
  color: #333;
  background-color: #e0f2ff;
  min-width: 20px;
  text-align: center;
}
</style>
